// extracted by mini-css-extract-plugin
export default {"stateReasonLink":"ClosedEvent-module__stateReasonLink--zoJ1G","closerLink":"ClosedEvent-module__closerLink--N3mNB"};